import { Component, OnInit, ViewChild, Output, EventEmitter, ChangeDetectorRef, Input, Inject, ViewChildren, forwardRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar, MatHorizontalStepper, MatDatepickerInputEvent } from '@angular/material';
import { MatFormFieldControl } from '@angular/material';
import { FormBuilder, Validators, FormControl, FormGroup, FormArray } from '@angular/forms';
import { LandingService } from '../../../providers/landing.service';
import { Http, Response } from '@angular/http';
import { GeneralService } from '../../../providers/general.service';
import { ListadoCamapanVentaComponent } from '../listado-campana-venta/listado-campana-venta.component';
import { ConfiguracionEmpresaService } from '../../../providers/configuracion-empresa.service';
import { PropuestasService } from '../../../providers/propuestas.service';
import { Router } from '@angular/router';
import { ZapierComponent } from '../zapier/zapier.component';
export enum StepperTitulos {
  CREAR_CAMPANA_VENTA = 0,
  CREAR_LANDING = 1,
}
@Component({
  selector: 'app-acciones-campana-venta',
  templateUrl: './acciones-campana-venta.component.html',
  styleUrls: ['./acciones-campana-venta.component.scss']
})
export class AccionesCampanaVentaComponent implements OnInit {
  constructor(
    public dialog: MatDialog,
    private router: Router,
    private generalSv: GeneralService
  ) { }
  data1: string;
  @Output() onCerrado = new EventEmitter();
  @Output() onAccionFinalizada = new EventEmitter();
  @Input() campana_venta: number;
  @Input() landing_id: number;
  @Input() object: any;
  @Input() botones: '1' | '2' | '3' | '4' | '5' | '6' | '7';

  ngOnInit() {
  }

  openDialog(object): void {
    const dialogRef = this.dialog.open(DialogAccionesCrearLanding, {
      width: '70vw',
      data: {
        idCampanaVenta: object.id,
        tipo_campania: object.tipo_campania,
        preguntar: true
      },
    });
    dialogRef.afterClosed().subscribe(resultado => {
      this.onCerrado.emit();
    });
  }

  redirect() {
    switch (this.object.tipo_campania) {
      case '1':
        this.router.navigate(['/logueado/crear-landing', this.object.id]);
        break;
      case '2':
        alert('Las campañas de email estan en construccion');
        // this.router.navigate(['/logueado/email']);
        break;
      case '3':
        this.openDialogZapier();
        break;
      default:
        break;
    }
  }

  openLanding(campana: any) {
    window.open(this.generalSv.web + 'assets/landing/index.html?id=' + campana.landings[0].id)
  }

  openDialogZapier() {
    const dialogRef = this.dialog.open(ZapierComponent, {
      width: '60vw',
      maxHeight: '80vh'
    });
    dialogRef.afterClosed().subscribe(resultado => {
    });
  }

  openDialogCampania() {
    const dialogRef = this.dialog.open(DialogAccionesCrearCampaniaVenta, {
      width: '70vw',
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(resultado => {
      this.onCerrado.emit();
    });
  }

  openDialogEditar(object) {
    const dialogRef = this.dialog.open(DialogAccionesEditarCampaniaVenta, {
      width: '70vw',
      data: { object }
    });
    dialogRef.afterClosed().subscribe(resultado => {
      this.onCerrado.emit();
    });
  }

  openDialogEditarLanding(object): void {
    const dialogRef = this.dialog.open(DialogAccionesEditarLanding, {
      width: '70vw',
      disableClose: true,
      data: { object }
    });
    dialogRef.afterClosed().subscribe(resultado => {
      this.onCerrado.emit();
    });
  }

  openDialogDetalleLanding(element): void {
    // console.log(element)
    const dialogRef = this.dialog.open(DialogDetalleLanding, {
      width: '50vw',
      data: { element }
    });
    dialogRef.afterClosed().subscribe(resultado => {
      this.onCerrado.emit();
    });
  }

}
@Component({
  selector: 'dialog-accion-crear-landing',
  templateUrl: 'dialog-accion-crear-landing.html',
  styleUrls: ['./acciones-campana-venta.component.scss'],

})


export class DialogAccionesCrearLanding implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<DialogAccionesCrearLanding>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private router: Router
  ) { }

  onNoClick() {
    this.dialogRef.close();
  }
  ngOnInit() {

  }

  redirect() {
    this.dialogRef.close();
    switch (this.data.tipo_campania) {
      case '1':

        this.router.navigate(['/logueado/crear-landing', this.data.idCampanaVenta]);
        break;
      case '2':

        this.router.navigate(['/logueado/email']);
        break;
      case '3':

        this.router.navigate(['/logueado/zapier']);
        break;
      default:
        break;
    }
  }
}
interface EstadosPropuesta {
  id: string;
  descripcion: string;
}

@Component({
  selector: 'dialog-accion-crear-camapania-venta',
  templateUrl: './dialog-accion-crear-camapania-venta.html',
  styleUrls: ['./acciones-campana-venta.component.scss'],

})


export class DialogAccionesCrearCampaniaVenta implements OnInit {
  error: string;
  constructor(
    private _fb: FormBuilder,
    private dialogRef: MatDialogRef<DialogAccionesCrearCampaniaVenta>,
    private _landingSv: LandingService,
    private _propuestaSv: PropuestasService,
    private cd: ChangeDetectorRef,
    public snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,

  ) { }
  @ViewChild(DialogAccionesCrearLanding) crearLanding: DialogAccionesCrearLanding;
  @ViewChild(MatHorizontalStepper) stepper: MatHorizontalStepper;

  tipoCampanaSeleccionada: any = false;
  cargando: boolean[] = [];
  cargandoEstados: boolean = false;
  object: object;
  minDate = new Date();
  maxDate: any;
  propuestaEstados: EstadosPropuesta[] = [];
  IdCamapanaVenta: number;
  accion = "Crear"
  form = this._fb.group({
    nombre: [null, Validators.required],
    fecha_desde: [null, Validators.required],
    fecha_hasta: [null, Validators.required],
    propuesta_estado: [null, Validators.required]
  })
  ngOnInit() {
    this.getStatus();
  }
  getStatus() {
    this.propuestaEstados = [];
    this.cargandoEstados = true;
    this._propuestaSv.getStatus().subscribe(
      respuesta => {
        this.cargandoEstados = false;
        if (respuesta.estado == 1 && respuesta.data) {
          respuesta.data.forEach((estado: any) => {
            this.propuestaEstados.push({
              id: estado.id,
              descripcion: estado.descripcion,
            });
          });
        }
      },
      error => {
        this.cargandoEstados = false;
      }
    );
  }
  onNoClick() {

    this.dialogRef.close();
  }
  continuar(): void {
    this.stepper.selected.completed = true;
    this.stepper.next();
  }
  addEvent(type: string, event: MatDatepickerInputEvent<Date>) {
    this.maxDate = new Date(this.form.controls['fecha_hasta'].value)
  }
  cambiarFecha() {

  }

  selectTipoCampana(tipoCampana) {
    switch (tipoCampana) {
      case 'landing':
        this.tipoCampanaSeleccionada = '1';
        break;
      case 'email':
        this.tipoCampanaSeleccionada = '2';
        break;
      case 'zapier':
        this.tipoCampanaSeleccionada = '3';
        break;

      default:
        break;
    }
  }

  submit() {
    if (this.form.valid) {
      this.object = {
        "campania_venta": {
          "nombre": this.form.controls['nombre'].value,
          "fecha_desde": this.form.controls['fecha_desde'].value,
          "fecha_hasta": this.form.controls['fecha_hasta'].value,
          "propuesta_status_carga_id": this.form.controls['propuesta_estado'].value,
          "tipo_campania": this.tipoCampanaSeleccionada
        }
      }
      this.cargando.push(true);
      this._landingSv.crearCampaniaVenta(this.object).subscribe(
        respuesta => {
          this.cargando.pop();
          this.IdCamapanaVenta = respuesta.data.campania_venta.id;
          if (respuesta.estado == 1) {
            this.snackBar.open(respuesta.mensaje, 'OK', { duration: 2750 });
            this.dialogRef.close();
            this.openDialog(this.IdCamapanaVenta, this.tipoCampanaSeleccionada);
          }
        }
      );
    }
  }

  openDialog(idCampanaVenta, tipoCampana): void {
    const dialogRef = this.dialog.open(DialogAccionesCrearLanding, {
      width: '50vw',
      data: {
        idCampanaVenta: idCampanaVenta,
        tipo_campania: tipoCampana
      },
    });
    dialogRef.afterClosed().subscribe(resultado => {
    });
  }
}
@Component({
  selector: 'dialog-accion-editar-camapania-venta',
  templateUrl: './dialog-accion-crear-camapania-venta.html',
  styleUrls: ['./acciones-campana-venta.component.scss'],

})
export class DialogAccionesEditarCampaniaVenta implements OnInit {
  constructor(
    private _fb: FormBuilder,
    private dialogRef: MatDialogRef<DialogAccionesCrearCampaniaVenta>,
    private _landingSv: LandingService,
    private cd: ChangeDetectorRef,
    public snackBar: MatSnackBar,
    private _generalSv: GeneralService,
    private _propuestaSv: PropuestasService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }
  accion = "EDITAR";
  object: any;
  propuestaEstados: EstadosPropuesta[] = [];
  cargandoEstados: boolean = false;
  cargando: boolean[] = [];
  minDate: any;
  maxDate: any;
  link = this._generalSv.web;
  form = this._fb.group({
    nombre: [, Validators.required],
    fecha_desde: [, Validators.required],
    fecha_hasta: [, Validators.required],
    propuesta_estado: [null, Validators.required]
  })
  datos = this.data['object'];
  tipoCampanaSeleccionada: any;

  ngOnInit() {
    this.setValue();
    this.getStatus();
  }
  getStatus() {
    this.propuestaEstados = [];
    this.cargandoEstados = true;
    this._propuestaSv.getStatus().subscribe(
      respuesta => {
        this.cargandoEstados = false;
        if (respuesta.estado == 1 && respuesta.data) {
          respuesta.data.forEach((estado: any) => {
            this.propuestaEstados.push({
              id: estado.id,
              descripcion: estado.descripcion,
            });
          });
        }
      },
      error => {
        this.cargandoEstados = false;
      }
    );
  }

  onNoClick() {
    this.dialogRef.close();
  }
  addEvent(type: string, event: MatDatepickerInputEvent<Date>) {
    this.maxDate = new Date(this.form.controls['fecha_hasta'].value)
  }
  setValue() {
    this.form.controls['nombre'].setValue(this.datos['nombre']);
    this.form.controls['fecha_desde'].setValue(this.datos['fecha_desde']);
    this.form.controls['fecha_hasta'].setValue(this.datos['fecha_hasta']);
    this.form.controls['propuesta_estado'].setValue(this.datos['propuesta_status_carga_id']);
    this.tipoCampanaSeleccionada = this.datos['tipo_campania'];
  }
  selectTipoCampana(tipoCampana) {
    switch (tipoCampana) {
      case 'landing':
        this.tipoCampanaSeleccionada = '1';
        break;
      case 'email':
        this.tipoCampanaSeleccionada = '2';
        break;
      case 'zapier':
        this.tipoCampanaSeleccionada = '3';
        break;

      default:
        break;
    }
  }
  submit() {
    this.object = {
      "campania_venta": {
        "nombre": this.form.controls['nombre'].value,
        "fecha_desde": this.form.controls['fecha_desde'].value,
        "fecha_hasta": this.form.controls['fecha_hasta'].value,
        "propuesta_status_carga_id": this.form.controls['propuesta_estado'].value,
        "id": this.data['object']['id'],
        "tipo_campania": this.tipoCampanaSeleccionada
      }
    }
    this.cargando.push(true);
    this._landingSv.editarCampania(this.object).subscribe(
      respuesta => {
        this.cargando.pop();
        if (respuesta.estado == 1) {
          this.snackBar.open(respuesta.mensaje, 'OK', { duration: 2750 });
          this.dialogRef.close();
        }
      }
    );
  }
}
@Component({
  selector: 'dialog-accion-editar-landing',
  templateUrl: 'dialog-accion-crear-landing.html',
  styleUrls: ['./acciones-campana-venta.component.scss'],

})
export class DialogAccionesEditarLanding implements OnInit {
  imagenUrl: any;
  checked: boolean;
  constructor(
    private _fb: FormBuilder,
    public dialog: MatDialog,
    private dialogRef: MatDialogRef<DialogAccionesEditarLanding>,
    private _landingSv: LandingService,
    private cd: ChangeDetectorRef,
    public snackBar: MatSnackBar,
    public _generalSv: GeneralService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _confSv: ConfiguracionEmpresaService,
    private router: Router
  ) { }

  accion = "EDITAR";
  cargando: boolean[] = [];
  base64Image: any[] = [];
  base64Logo: string = '';
  object: any;
  campos: any;
  checkear: boolean;
  step = '2';
  imagenesId = [];
  link = this._generalSv.web;
  redesSociales: FormArray;
  formLanding = this._fb.group({
    logo: [],
    titulo: [null, Validators.required],
    descripcion: [null, Validators.required],
    imagenes: [],
    employees: this._fb.array([this.camposDisponibles()]),
    redesSociales: this._fb.group({
      facebook: '',
      instagram: '',
      twitter: ''
    })
  })
  datosLanding: any;
  datos = this.data['object'];
  ngOnInit() {
    this.getLandings();
    this.getConfiguracion();
  }
  getConfiguracion() {
    this._confSv.getConfiguracion().subscribe(
      respuesta => {
        if (respuesta.data && respuesta.data.logo) {
          this.base64Logo = respuesta.data.logo;
        }
      }
    )
  }
  onNoClick() {
    this.dialogRef.close();
  }
  eliminarImagenesUpload() {
    this.base64Image = [];
  }
  eliminarLogoUpload() {
    this.base64Logo = '';
    this.snackBar.open("Imagen eliminada correctamente", 'OK', { duration: 2750 });
  }
  uploadLogoFinished(ev) {
    this.base64Logo = ev.src;
  }
  uploadFinished(ev) {
    this.base64Image.push(ev.src);
  }

  redirect() {
    switch (this.object.tipo_campania) {
      case '1':
        this.router.navigate(['/logueado/crear-landing', this.object.id]);
        break;
      case '2':
        alert('Las campañas de email estan en construccion');
        // this.router.navigate(['/logueado/email']);
        break;
      case '3':
        this.openDialogZapier();
        break;
      default:
        break;
    }
  }

  openDialogZapier() {
    const dialogRef = this.dialog.open(ZapierComponent, {
      width: '60vw',
      maxHeight: '80vh'
    });
    dialogRef.afterClosed().subscribe(resultado => {
    });
  }

  camposDisponibles() {
    const respuestaCampos = this._fb.group({});
    this._landingSv.getCamposDisponibles("").subscribe(
      respuesta => {
        this.campos = respuesta.data
        this.campos.forEach(apiRespuesta => {
          respuestaCampos.addControl(apiRespuesta.nombre, new FormControl(''));
        });

      }
    );
    return respuestaCampos;
  }
  addEmployerToFormArray() {
    this.employeeRows.push(this.camposDisponibles());
  }
  get employeeRows() {
    return (<FormArray>this.formLanding.get('employees'));
  }
  getLandings() {
    this.datosLanding = this.data['object'].landings[0]
    this.datosLanding.imagenes = [];
    this.cargando.push(true);
    this._landingSv.getLanding({
      "filtros": {
        "id": this.datosLanding.id
      }
    }).subscribe(
      respuesta => {
        this.cargando.pop();
        this.datosLanding = respuesta.data[0]
        this.formLanding.controls['titulo'].setValue(this.datosLanding['titulo']);
        this.formLanding.controls['descripcion'].setValue(this.datosLanding['descripcion']);
        this.datosLanding.campos.forEach(apiRespuesta => {
          this.campos.forEach(element => {
            if (apiRespuesta['nombre'] == element['nombre']) {
              const controlArray = <FormArray>this.formLanding.get('employees');
              controlArray.controls[0].get(element['nombre']).setValue(true);
            }
          });
        });
        this.datosLanding.redes_sociales.forEach(element => {
          let redSocial = element.nombre;
          let url = element.url;
          let redesSociales = [];
          redesSociales.push({
            redSocial: url
          })
          this.formLanding.get(['redesSociales', redSocial]).setValue(url);
        });
        // array con id de imagenes
        this.datosLanding.imagenes.forEach(imagenes => {
          if (imagenes['tipo'] == 'logo') {
            let index = this.datosLanding.imagenes.indexOf(imagenes);
            this.base64Logo = imagenes['blob'];
            if (index !== -1)
              this.datosLanding.imagenes.splice(index, 1);
          } else {
            this.imagenesId.push(imagenes["id"]);
          }
        });
        // console.log(this.imagenesId);
      }
    );
  }
  eliminarImagen(id) {
    // escondo la imagen en el html
    document.getElementById("img-" + id).style.display = "none";
    // busco la imagen en el array y la elimino
    var index = this.imagenesId.indexOf(id);
    if (index !== -1)
      this.imagenesId.splice(index, 1);

    this.snackBar.open("Imagen eliminada correctamente", 'OK', { duration: 2750 });
  }

  submit() {
    this.cargando.push(true);
    this.object =
    {
      "landing": {
        "titulo": this.formLanding.controls['titulo'].value,
        "descripcion": this.formLanding.controls['descripcion'].value,
        "id": this.data['object'].landings[0].id
      },
    }
    this.object["landing_campos"] = [];
    this.object['landing_imagenes'] = [];
    this.object['landing_redes_sociales'] = [];
    this.formLanding.controls['employees'].value.forEach(campos => {
      this.campos.forEach(apiCampos => {
        if (campos[apiCampos["nombre"]]) {
          this.object["landing_campos"].push({
            "landing_campo_disponible_id": apiCampos["id"],
            "nombre": apiCampos["nombre"]
          });
        }
      });
    });
    if (this.base64Image) {
      let count = 0;
      for (let key in this.base64Image) {
        count++;
        let value = this.base64Image[key];
        this.object['landing_imagenes'].push({
          "nombre": "img_" + count,
          "blob": value
        });
      }
    }
    if (this.imagenesId) {
      let count = 0;
      this.imagenesId.forEach(imagenes => {
        count++;
        this.object['landing_imagenes'].push({
          "nombre": "img_" + count,
          "id": imagenes
        });
      });
    }
    if (this.base64Logo != '') {
      this.object['landing_imagenes'].push({
        "nombre": "img_logo",
        "blob": this.base64Logo,
        'tipo': 'logo'
      });
    }

    const objeto = this.formLanding.controls.redesSociales.value;
    Object.keys(objeto).forEach(key => {
      const valor = objeto[key];
      this.object['landing_redes_sociales'].push({
        "nombre": key,
        "url": valor
      });
    })

    this._landingSv.editarLanding(
      this.object
    ).subscribe(
      respuesta => {
        this.cargando.pop();
        if (respuesta.estado == 1) {
          this.snackBar.open(respuesta.mensaje, 'OK', { duration: 2750 });
          this.dialogRef.close();
        }
      }
    );
  }
}
@Component({
  selector: 'dialog-detalle-landing',
  templateUrl: 'dialog-detalle-landing.html',
  styleUrls: ['./acciones-campana-venta.component.scss'],

})
export class DialogDetalleLanding implements OnInit {
  link: string;
  constructor(
    private _fb: FormBuilder,
    private dialogRef: MatDialogRef<DialogDetalleLanding>,
    private _landingSv: LandingService,
    private cd: ChangeDetectorRef,
    public snackBar: MatSnackBar,
    public generalSv: GeneralService,
    private http: Http,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }
  env: any;
  cargando: boolean[] = [];
  datosLanding: any;
  campana_id = this.data['object'] ? this.data['object'].id : this.data['element'].id
  linkShare: string;
  ngOnInit() {
    this.getLanding();
  }
  onNoClick() {
    this.dialogRef.close();
  }
  copyInputMessage(inputElement) {
    inputElement.select();
    document.execCommand('copy');
    inputElement.setSelectionRange(0, 0);
  }
  getLanding() {
    this.cargando.push(true);
    this._landingSv.getLanding({
      "filtros": {
        "id": this.data['object'] ? this.data['object'] : this.data['element'].landings[0].id
      }
    }).subscribe(
      respuesta => {
        this.cargando.pop();
        this.datosLanding = respuesta.data[0];
        this.link = this.generalSv.web;
        let link = this.link.replace('://', '%3A%2F%2F');
        link = link.replace('/', '%2F');
        this.linkShare = 'https://www.facebook.com/sharer/sharer.php?u=' + link + 'assets%2Flanding%2Findex.html%3Fface%3D' + this.datosLanding.id + '&amp;src=sdkpreparse';
      }
    )
  }
  irADemo(id) {
    window.open(this.link + "assets/landing/index.html?id=" + id, "_blank");
  }
  irALanding() {
    this.router.navigate(['/logueado/crear-landing/', this.campana_id, this.datosLanding.id]);
    this.dialogRef.close();
  }
}

